"use client";

import { Sprout, Facebook, Instagram, Phone, Mail, MapPin, Send } from "lucide-react";

const links = [
  { href: "#accueil", label: "Accueil" },
  { href: "#histoire", label: "Histoire" },
  { href: "#produits", label: "Produits" },
  { href: "#transformation", label: "Transformation" },
  { href: "#infrastructure", label: "Infrastructure" },
  { href: "#logistique", label: "Logistique" },
  { href: "#ecole", label: "École" },
  { href: "#export", label: "Export" },
  { href: "#valeurs", label: "Valeurs" },
  { href: "#galerie", label: "Galerie" },
  { href: "#contact", label: "Contact" },
];

const productLinks = [
  "Patate douce",
  "Pomme de terre",
  "Manioc",
  "Igname",
  "Farine de manioc",
  "Chips de patate",
  "Attiéké",
];

export function SiteFooter() {
  const handleNav = (href: string) => {
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="relative bg-earth-deep text-cream/80 pt-16 pb-8 mt-auto">
      {/* Gold top border */}
      <div className="absolute top-0 inset-x-0 h-px bg-gradient-to-r from-transparent via-gold to-transparent" />

      <div className="container mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-12 gap-10">
          {/* Brand */}
          <div className="md:col-span-4">
            <div className="flex items-center gap-3 mb-4">
              <span className="grid place-items-center w-11 h-11 rounded-full bg-gradient-gold shadow-gold">
                <Sprout className="w-5 h-5 text-white" />
              </span>
              <div>
                <div className="font-display text-xl font-extrabold text-gradient-gold">
                  PATATE OR
                </div>
                <div className="text-[10px] uppercase tracking-[0.32em] text-cream/50">
                  Racines · Tubercules · Or
                </div>
              </div>
            </div>
            <p className="text-sm leading-relaxed text-cream/70 max-w-xs">
              La maison des racines et tubercules d&apos;exception. Patate douce, pomme de
              terre, manioc, igname et produits transformés. Vente directe, du producteur
              à votre table.
            </p>

            {/* Social */}
            <div className="mt-6 flex items-center gap-3">
              {[Facebook, Instagram, Send].map((Icon, i) => (
                <a
                  key={i}
                  href="#"
                  aria-label="Réseau social"
                  className="grid place-items-center w-9 h-9 rounded-full bg-cream/10 hover:bg-gradient-gold transition-colors"
                >
                  <Icon className="w-4 h-4 text-cream hover:text-white" />
                </a>
              ))}
            </div>
          </div>

          {/* Navigation */}
          <div className="md:col-span-2">
            <h4 className="font-display text-sm font-bold text-cream uppercase tracking-wider mb-4">
              Navigation
            </h4>
            <ul className="space-y-2.5">
              {links.map((l) => (
                <li key={l.href}>
                  <button
                    onClick={() => handleNav(l.href)}
                    className="text-sm text-cream/70 hover:text-gold transition-colors text-left"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Products */}
          <div className="md:col-span-3">
            <h4 className="font-display text-sm font-bold text-cream uppercase tracking-wider mb-4">
              Nos Produits
            </h4>
            <ul className="space-y-2.5">
              {productLinks.map((p) => (
                <li key={p}>
                  <button
                    onClick={() => handleNav("#produits")}
                    className="text-sm text-cream/70 hover:text-gold transition-colors text-left"
                  >
                    {p}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="md:col-span-3">
            <h4 className="font-display text-sm font-bold text-cream uppercase tracking-wider mb-4">
              Contact
            </h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-gold mt-0.5 shrink-0" />
                <span className="text-cream/70">
                  Ndiamsyl Peye, Smartest Capital — Cultures &amp; Usine de transformation
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-4 h-4 text-gold shrink-0" />
                <a href="tel:+22500000000" className="text-cream/70 hover:text-gold">
                  +225 00 00 00 00 00
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 text-gold mt-0.5 shrink-0" />
                <a
                  href="mailto:contact@patate-or.ligue-islamique.online"
                  className="text-cream/70 hover:text-gold break-all"
                >
                  contact@patate-or.ligue-islamique.online
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-6 border-t border-cream/10 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs">
          <p className="text-cream/60">
            © {new Date().getFullYear()} PATATE OR — patate-or.ligue-islamique.online.
            Tous droits réservés.
          </p>
          <p className="text-cream/60 flex items-center gap-2">
            <span>Conçu avec</span>
            <span className="text-gold">♥</span>
            <span>pour les amoureux de la terre</span>
          </p>
        </div>
      </div>
    </footer>
  );
}
